/** 账号记录 */
export const CancelOrderListFields = {
    /* 记录流水号 */
    recordNo: 'recordNumber',

    /* 关联单号 */
    relationNo: 'associatedNumber',

    /* 补贴对象 */
    target: 'mobile',

    /* 补贴金额(元) */
    subsidyMoney: 'subsidyAmount',

    /* 备注 */
    remark: 'remark',

    /** 变动时间 */
    changeTime: 'updateDate'
};

/** Tab类型 */
export const TabType = {
    /** 取消订单 */
    CancelOrder: 'CancelOrder'
};